<template>
  <content-section
    class="form-section mt-12 pt-12 border-t-2"
  >
    <template #title>
      <h2>Bank Details</h2>
      <div
        class="italic text-sm text-grey-700"
      >
        <p>Please provide us with your bank details that you wish for the funds to be released.</p>
        <p>You payment reference will be: <strong>{{ project.ref }}</strong></p>
        <p class="text-negative-500">
          <icon
            icon="important"
            class="w-4 h-4 icons-negative mr-1 align-text-bottom"
          />
          <strong>All these fields are required.</strong>
        </p>
      </div>
    </template>

    <div class="-mx-6 flex flex-wrap -mb-8">
      <input-default
        :error="errors.account_name"
        :input="{
          'key':'account_name',
          'type':'text',
          'label':'Account Name',
          'instructions':null,
          'attributes':{
            'placeholder':'Account Name',
            'default':null,
            'prepend':null,
            'append':null,
            'locked':loading,
            'required':true
          },
          'wrapper':{
            'width':'full'
          },
          'validation':{
            'min':false,
            'max':false,
            'limit': false
          }
        }"
        :application-value="details.account_name"
        @update:input="updateDetails"
      />
      <input-default
        :error="errors.sort_code"
        :input="{
          'key':'sort_code',
          'type':'text',
          'label':'Sort Code',
          'instructions':null,
          'attributes':{
            'placeholder':'xxxxxx',
            'default':null,
            'prepend':null,
            'append':null,
            'locked':loading,
            'required':true
          },
          'wrapper':{
            'width':'1/3'
          },
          'validation':{
            'min':false,
            'max':false,
            'limit': 6
          }
        }"
        :application-value="details.sort_code"
        @update:input="updateDetails"
      />
      <input-default
        :error="errors.account_number"
        :input="{
          'key':'account_number',
          'type':'text',
          'label':'Account Number',
          'instructions':null,
          'attributes':{
            'placeholder':'xxxxxxxx',
            'default':null,
            'prepend':null,
            'append':null,
            'locked':loading,
            'required':true
          },
          'wrapper':{
            'width':'2/3'
          },
          'validation':{
            'min':false,
            'max':false,
            'limit': 8
          }
        }"
        :application-value="details.account_number"
        @update:input="updateDetails"
      />
      <input-default
        :error="errors.bank_name"
        :input="{
          'key':'bank_name',
          'type':'text',
          'label':'Bank Name',
          'instructions':null,
          'attributes':{
            'placeholder':'e.g. HSBC',
            'default':null,
            'prepend':null,
            'append':null,
            'locked':loading,
            'required':true
          },
          'wrapper':{
            'width':'full'
          },
          'validation':{
            'min':false,
            'max':false,
            'limit': false
          }
        }"
        :application-value="details.bank_name"
        @update:input="updateDetails"
      />
      <input-default
        :error="errors.bank_address"
        :input="{
          'key':'bank_address',
          'type':'text',
          'label':'Bank Address',
          'instructions':null,
          'attributes':{
            'placeholder': null,
            'default':null,
            'prepend':null,
            'append':null,
            'locked':loading,
            'required':true
          },
          'wrapper':{
            'width':'full'
          },
          'validation':{
            'min':false,
            'max':false,
            'limit': false
          }
        }"
        :application-value="details.bank_address"
        @update:input="updateDetails"
      />
    </div>
  </content-section>
</template>
<script>
export default {
  name: 'AccountDetails',
  props: {
    errors: {
      type: Object,
      default: () => ({})
    },
    details: {
      type: Object,
      required: true
    },
    project: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    updateDetails({key,value}) {
      this.details[key] = value
    }
  }
}
</script>

